import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  FormControl,
  Input,
  InputGroup,
  InputRightElement,
  Progress,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PasswordChangedModal from "./password-success";
import {
  StyledModalHeader,
  Subtext,
  PasswordHint,
  ToggleButton,
  ResetPasswordButton,
  StyledFormLabel,
} from "./style";
import { EyeIcon } from "./eyeicon";
import { EyeOffIcon } from "./eyeofficon";
import { useGlobalContext } from "@root/context/global-context";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { calculateStrength } from "@root/utils";

const ChangePasswordModal = ({ isOpen, onClose,onSuccess }: ChangePasswordProps) => {
  const { t } = useTranslation("common");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [touched, setTouched] = useState(false);

  const { updatePassword, resetPasswordLoading } = useGlobalContext();
  const user: any = useSelector(getLoggedInUser);



  const passwordStrength = calculateStrength(newPassword);
  const isPasswordValid = passwordStrength === 100;
  const doPasswordsMatch = newPassword === confirmPassword;
  const allFieldsFilled = oldPassword && newPassword && confirmPassword;
  const canSubmit = isPasswordValid && doPasswordsMatch && allFieldsFilled;

  const handleResetPassword = async () => {
    const payload = {
      old_password: oldPassword,
      new_password: newPassword,
    };

    const isSuccess = await updatePassword(payload);
    console.log(isSuccess);

    if (isSuccess) {
      console.log(" i am called");
      onClose(); // close current modal
      setIsSuccessModalOpen(true); 
      if (onSuccess) onSuccess();
    }
  };

  return (
    <>
      {/* Main Change Password Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0, 0, 0, 0.4)" />
        <ModalContent
          maxW="500px"
          bg="#FFFFFF"
          borderRadius="16px"
          p={6}
          boxShadow="lg"
          fontWeight={"400"}
        >
          <StyledModalHeader>
            {t("userProfile.changePassword")}
          </StyledModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Subtext>{t("userProfile.securePassword")}</Subtext>

            {/* Old Password */}
            <FormControl mb={4}>
              <StyledFormLabel>{t("userProfile.oldPassword")}</StyledFormLabel>
              <InputGroup>
                <Input
                  border="1px"
                  borderColor="#D0D5DD"
                  type={showOld ? "text" : "password"}
                  placeholder={t("userProfile.enterOldPassword")}
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
                <InputRightElement>
                  <ToggleButton onClick={() => setShowOld(!showOld)}>
                    
                  </ToggleButton>
                </InputRightElement>
              </InputGroup>
            </FormControl>

            {/* New Password */}
            <FormControl mb={4}>
              <StyledFormLabel>{t("userProfile.newPassword")}</StyledFormLabel>
              <InputGroup>
                <Input
                  border="1px"
                  borderColor="#D0D5DD"
                  type={showNew ? "text" : "password"}
                  placeholder={t("userProfile.enterNewPassword")}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setTouched(true);
                  }}
                />
                <InputRightElement>
                  <ToggleButton onClick={() => setShowNew(!showNew)}>
                   
                  </ToggleButton>
                </InputRightElement>
              </InputGroup>
              <PasswordHint
                color={touched && !isPasswordValid ? "red.500" : "gray.500"}
              >
                {t("userProfile.passwordInstruction")}
              </PasswordHint>
              <Progress
                mt={2}
                value={passwordStrength}
                size="xs"
                colorScheme={isPasswordValid ? "green" : "red"}
                borderRadius="full"
              />
            </FormControl>

            {/* Confirm Password */}
            <FormControl mb={6}>
              <StyledFormLabel>
                {t("userProfile.confirmPassword")}
              </StyledFormLabel>
              <InputGroup>
                <Input
                  border="1px"
                  borderColor="#D0D5DD"
                  type={showConfirm ? "text" : "password"}
                  placeholder={t("userProfile.confirmPassword")}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <InputRightElement>
                  <ToggleButton onClick={() => setShowConfirm(!showConfirm)}>
                    
                  </ToggleButton>
                </InputRightElement>
              </InputGroup>
              {touched && !doPasswordsMatch && (
                <PasswordHint color="red.500">
                  {t("userProfile.passwordMismatch")}
                </PasswordHint>
              )}
            </FormControl>

            <ResetPasswordButton
              onClick={handleResetPassword}
              isDisabled={!canSubmit}
              isLoading={resetPasswordLoading}
            >
              {t("userProfile.resetPassword")}
            </ResetPasswordButton>
          </ModalBody>
        </ModalContent>
      </Modal>

      <PasswordChangedModal
        isOpen={isSuccessModalOpen}
        onClose={() => setIsSuccessModalOpen(false)}
      />
    </>
  );
};

export default ChangePasswordModal;
